import React from "react"
import Title from "./Title"
import Project from "./Project"
import { Link } from "gatsby"
import "../css/project.css"


const Projects = ({projects, title, showLink}) => {
  return <section className="section posts section-center">
  <Title title={title}  />
  <div className="posts-center">
    <article className="hi">
    {
        projects.map((project, index) => {
          return <Project key={project.id} index={index} {...project} />
        })
      }
    </article>
  </div>
  {
      showLink && <Link to="/projects" className="btn center-btn">All Projects</Link>
    }
</section>
}



export default Projects


